import Logger from '@/lib/logger';
import { NEXT_PUBLIC_META_PIXEL_LOGGING_ENABLED } from '@/lib/env';

const logger = new Logger('MetaPixel', 'DEBUG');

if (NEXT_PUBLIC_META_PIXEL_LOGGING_ENABLED) {
  logger.enable();
}

export default logger;
